/* eslint-disable react/no-danger */
import {
  getBalance,
  getCardImage,
  getCardValue,
  getDisplayNameForPlatform,
  getLocalizedPlatformName,
} from '../../utils';
import parse, {HTMLReactParserOptions} from 'html-react-parser';

import {localizedMessage} from '../message/Message';
import {PosaRedeemStore} from '../../utils/types';
import React from 'react';

export interface HTMLReactParserOptionsHtmlTemplate extends HTMLReactParserOptions {
  trim?: boolean;
}

const transformTemplateString = (string, posaRedeemStore, accountName) => {
  if (!string) return '';
  if (!posaRedeemStore) return string;
  const {
    platform,
    externalAuths,
    epicAccountName,
    offer,
    wallets,
    psnRegion,
    secondaryCode: secondaryCodeObj = {},
  } = posaRedeemStore;
  const platformDisplayName = getDisplayNameForPlatform(platform, externalAuths);
  const deviceName = getLocalizedPlatformName(platform, localizedMessage);
  const cardImage = getCardImage(offer);
  const cardBalance = getCardValue(offer);
  const accountBalance = getBalance(wallets, platform);
  const secondaryCode = secondaryCodeObj.code || '';
  const psnRegionName = localizedMessage(`epic.code.redemption.psn.region.${psnRegion}`);
  const transformed = string
    .replace('{epicAccountName}', accountName || epicAccountName || '')
    .replace('{platform}', deviceName)
    .replace('{platformDisplayName}', platformDisplayName)
    .replace('{secondaryCode}', secondaryCode)
    .replace('{psnRegionName}', psnRegionName)
    .replace('{cardBalance}', cardBalance)
    .replace('{cardImage}', cardImage)
    .replace('{accountBalance}', accountBalance);

  return transformed;
};

interface Props {
  posaRedeemStore?: PosaRedeemStore;
  string: string;
  Tag?: keyof JSX.IntrinsicElements;
  className?: string;
  accountName?: string;
  useDangerouslySetInnerHTML?: boolean;
  isTemplate?: boolean;
  options?: HTMLReactParserOptionsHtmlTemplate;
}

/**
 * replate template strings with actual values
 */
const PosaTemplate = ({
  posaRedeemStore,
  useDangerouslySetInnerHTML,
  Tag,
  className,
  isTemplate,
  options,
  string,
  accountName,
}: Props) => {
  const transformed = transformTemplateString(string, posaRedeemStore, accountName);
  if (isTemplate) {
    const reactElement = parse(transformed, options);
    if (Tag) {
      return <Tag className={className}>{reactElement}</Tag>;
    }
    return <>{reactElement}</>;
  }

  if (!useDangerouslySetInnerHTML) {
    if (Tag) {
      return <Tag className={className}>{transformed}</Tag>;
    }
    return <>{transformed}</>;
  }

  if (Tag) {
    return (
      <React.Fragment>
        <Tag className={className} dangerouslySetInnerHTML={{__html: transformed}} />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <span className={className} dangerouslySetInnerHTML={{__html: transformed}} />
    </React.Fragment>
  );
};

export default PosaTemplate;
